import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function CityInput({ value, onChange }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const typed = useRef(false);

  useEffect(() => {
    const q = (value || "").trim();
    if (!typed.current || q.length < 2) { setItems([]); return; }
    const ctrl = new AbortController();
    const t = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/lookup/cities`, { params: { q }, signal: ctrl.signal });
        setItems(r.data.suggestions || []);
        setOpen(true);
      } catch {
        setItems([]);
      }
    }, 250);
    return () => { clearTimeout(t); ctrl.abort(); };
  }, [value]);

  const pick = (c) => {
    typed.current = false;
    onChange(c.city);
    setOpen(false);
  };

  return (
    <div className="relative">
      <input
        className="field-input"
        value={value}
        onChange={(e) => { typed.current = true; onChange(e.target.value); }}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onFocus={() => items.length && setOpen(true)}
        placeholder="Начните вводить город"
        autoComplete="off"
      />
      {open && items.length > 0 && (
        <div className="absolute z-20 left-0 right-0 mt-1 bg-white border border-black/15 shadow-sm" data-testid="founder-city-suggestions">
          {items.map((c, i) => (
            <button
              type="button"
              key={`${c.city}-${c.region}-${i}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => pick(c)}
              className="block w-full text-left px-4 py-2.5 text-sm hover:bg-black/5"
              data-testid={`founder-city-option-${i}`}
            >
              {c.city}{c.region && <span className="text-foreground/50"> · {c.region}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function TechPicker({ value, onChange }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    axios.get(`${API}/lookup/technologies`).then((r) => setOptions(r.data.technologies || [])).catch(() => {});
  }, []);

  const toggle = (key) => onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);

  return (
    <div className="flex flex-wrap gap-2" data-testid="founder-tech-picker">
      {options.map((o) => {
        const on = value.includes(o.key);
        return (
          <button
            type="button"
            key={o.key}
            onClick={() => toggle(o.key)}
            aria-pressed={on}
            data-testid={`founder-tech-${o.key}`}
            className={`px-3 py-1.5 text-sm border transition-colors duration-150 ${
              on ? "bg-black text-white border-black" : "border-black/20 hover:border-black/60"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export async function lookupCompany(inn) {
  const digits = (inn || "").replace(/\D/g, "");
  if (![10, 12].includes(digits.length)) return null;
  try {
    const r = await axios.get(`${API}/lookup/company`, { params: { inn: digits } });
    return r.data;
  } catch {
    return null;
  }
}
